export default [{
  path: '/mall-order-all',
  name: 'all-order-list',
  component: resolve => require(['views/all-order-list'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/renew-deposit-order-all',
  name: 'renew-deposit-order',
  component: resolve => require(['views/all-order-list'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/immune_storage-order-all',
  name: 'immune_storage-order',
  component: resolve => require(['views/all-order-list'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/mall-order-all/order-detail/:id/:operation',
  name: 'order-detail',
  props: true,
  component: resolve => require(['views/order-detail'], resolve),
  meta: { auth: true, view: 'pc', navInfo: '全部订单/订单详情' }
},
{
  path: '/mall-order-paid',
  name: 'paid-order-list',
  component: resolve => require(['views/paid-order-list'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/mall-order-refund',
  name: 'refund-order-list',
  component: resolve => require(['views/refund-order-list'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/mall-order-refund/order-detail/:id',
  name: 'refund-detail',
  props: true,
  component: resolve => require(['views/order-detail'], resolve),
  meta: { auth: true, view: 'pc', navInfo: '退款订单/订单详情' }
},
{
  path: '/waiting-for-sample-recollect',
  name: 'waiting-for-sample-recollect',
  component: resolve => require(['views/waiting-sample-recollect'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/waiting-for-sample-recollect/sample-recollect-detail/:sampleId',
  props: true,
  name: 'sample-recollect-detail',
  component: resolve => require(['views/sample-recollect-detail'], resolve),
  meta: { auth: true, view: 'pc', navInfo: '重采待处理订单/创建重采订单' }
},
{
  path: '/waiting-for-sample-recollect/sample-recollect-detail/:sampleId/:sampleType',
  props: true,
  name: 'sample-recollect-detail',
  component: resolve => require(['views/sample-recollect-detail'], resolve),
  meta: { auth: true, view: 'pc', navInfo: '重采待处理订单/创建重采订单' }
},
{
  path: '/export-history/order',
  props: true,
  name: 'export-history',
  component: resolve => require(['views/export-history'], resolve),
  meta: { auth: true, view: 'pc', navInfo: '全部订单/订单导出历史' }
}
]
